var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowPriorityTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.16663H27.5V8.66663H17.5V6.16663ZM17.5 13.0416H27.5V15.5416H17.5V13.0416ZM17.5 19.9166H27.5V22.4166H17.5V19.9166ZM2.5 14.2916C2.5 18.7666 6.15 22.4166 10.625 22.4166H11.25V24.9166L15 21.1666L11.25 17.4166V19.9166H10.625C7.525 19.9166 5 17.3916 5 14.2916C5 11.1916 7.525 8.66663 10.625 8.66663H15V6.16663H10.625C6.15 6.16663 2.5 9.81663 2.5 14.2916Z",
    fill: "#10B981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowPriorityTickets);
export default __webpack_public_path__ + "static/media/Low Priority Tickets.0dd74a4300778e9ea8d1d71ff1d73ced.svg";
export { ForwardRef as ReactComponent };